export const mockData = {
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      location: "Austin, TX",
      project: "Kitchen Renovation",
      rating: 5,
      comment: "I received 6 bids for my kitchen remodel and saved over $3,000 compared to the first quote I got elsewhere. The bidding process was eye-opening!",
      savings: "$3,200",
      avatar: "https://via.placeholder.com/150x150/10B981/FFFFFF?text=SJ"
    },
    {
      id: 2,
      name: "Mike Chen",
      location: "Seattle, WA", 
      project: "Bathroom Repair",
      rating: 5,
      comment: "The competitive bidding gave me so many options. I found a contractor who not only offered the best price but also had creative solutions I hadn't considered.",
      savings: "$850",
      avatar: "https://via.placeholder.com/150x150/059669/FFFFFF?text=MC"
    },
    {
      id: 3,
      name: "Linda Rodriguez",
      location: "Phoenix, AZ",
      project: "Home Electrical Work",
      rating: 5,
      comment: "As a single mom, getting multiple bids helped me feel confident I wasn't being overcharged. The transparency in pricing was exactly what I needed.",
      savings: "$1,100",
      avatar: "https://via.placeholder.com/150x150/0D9488/FFFFFF?text=LR"
    }
  ],
  
  faqs: [
    {
      question: "How does the bidding process work?",
      answer: "Simply post your project with details and photos. Qualified service providers in your area will review your project and submit competitive bids with their pricing, timeline, and approach. You then compare and choose the best offer."
    },
    {
      question: "How do you ensure service providers are qualified?",
      answer: "All service providers go through our verification process including license checks, insurance verification, background checks, and customer review analysis. We also use a rating system based on completed projects."
    },
    {
      question: "What if I'm not satisfied with the work?",
      answer: "We offer project protection and dispute resolution services. If issues arise, our team mediates between you and the service provider. We also maintain a guarantee fund for qualifying projects."
    },
    {
      question: "How long does it take to receive bids?",
      answer: "Most projects start receiving bids within 4-6 hours of posting. The majority of projects receive 3-7 bids within 24-48 hours, depending on the project complexity and location."
    },
    {
      question: "Is there a fee to post projects?",
      answer: "Posting projects is completely free for homeowners. We only charge a small service fee to providers when they win a project, ensuring our interests are aligned with connecting you to the best professionals."
    },
    {
      question: "Can I negotiate with service providers?",
      answer: "Absolutely! After reviewing initial bids, you can message providers to discuss details, ask questions, or negotiate terms. Many successful projects involve some back-and-forth discussion before final selection."
    }
  ],

  stats: {
    projectsCompleted: "2,500+",
    serviceProviders: "1,200+",
    averageRating: "4.9",
    avgSavings: "18%",
    avgBidsPerProject: "4.2"
  },

  serviceCategories: [
    "Kitchen Remodeling",
    "Bathroom Repairs", 
    "Electrical Work",
    "Plumbing Services",
    "Painting & Decorating",
    "Flooring Installation",
    "HVAC Services",
    "Roofing Repairs",
    "Landscaping",
    "General Handyman"
  ]
};